function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.976,32a2.009,2.009,0,0,1,2,2.281,29.247,29.247,0,0,1-46.135,19.1,1.987,1.987,0,0,1-.205-3.011l6.528-6.487a2.018,2.018,0,0,1,2.484-.276A16.133,16.133,0,0,0,45.811,33.572,2.012,2.012,0,0,1,47.77,32Z",
    style: {
      fill: "#37cba1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.978,27.871H47.772a2.027,2.027,0,0,1-1.965-1.6A16.127,16.127,0,0,0,33.726,14.192a2.025,2.025,0,0,1-1.6-1.965v-9.2a2.014,2.014,0,0,1,2.289-2A29.15,29.15,0,0,1,58.979,25.582,2.015,2.015,0,0,1,56.978,27.871Z",
    style: {
      fill: "#fccb55"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,3.024V12.23a2.012,2.012,0,0,1-1.572,1.959,16.128,16.128,0,0,0-9.962,24.269,2.017,2.017,0,0,1-.267,2.5L9.717,47.479a1.988,1.988,0,0,1-3.007-.2A29.249,29.249,0,0,1,25.719,1.023,2.009,2.009,0,0,1,28,3.024Z",
    style: {
      fill: "#9e82ec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,39a1,1,0,0,1-.707-1.707l16-16a1,1,0,0,1,1.414,1.414l-16,16A1,1,0,0,1,22,39Z",
    style: {
      fill: "#346d92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,28a3,3,0,1,1,3-3A3,3,0,0,1,25,28Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,25,24Z",
    style: {
      fill: "#346d92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,38a3,3,0,1,1,3-3A3,3,0,0,1,35,38Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,35,34Z",
    style: {
      fill: "#346d92"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.47b65e43eb32c3d88daff7de28c737b7.svg";
export { ForwardRef as ReactComponent };